<template>
  <div class="upload-two">
    <el-upload
      class="avatar-uploader"
      id="avatar-uploader3"
      accept="image/*"
      ref="uploader"
      :action="uploadImage"
      :on-error="uploadError"
      :on-exceed="uploadExc"
      :on-preview="handlePreview"
      :on-remove="handleRemove"
      :headers="headers"
      :on-success="uploadSuccessOne"
      :before-upload="beforeUp"
      list-type="picture"
      :show-file-list="false"
      :disabled="ifDisable"
    >
      <i class="el-icon-plus avatar-uploader-icon" v-if="!picUrl"></i>
      <div v-if="!picUrl" class="el-upload__text">{{ placeWord }}</div>
      <div
        v-if="picUrl"
        :style="{ backgroundImage: 'url(' + picUrl + ')' }"
        class="showPic"
      ></div>
    </el-upload>
  </div>
</template>

<script>
import { upLoadImg } from '@/Mixin/upLoadImg';
import { uploadImage } from '@/api/ajax';
import CanvasDialog from './CanvasDialog';
export default {
  props: {
    ifDisable: {
      type: Boolean,
      default: false
    },
    initDone: {
      // 外层初始化完毕
      type: Boolean,
      default: false
    },
    initUrl: {
      // 初始化图片
      type: String,
      default: ''
    },
    placeWord: {
      type: String,
      default: ''
    },
    noNeedDefaultImg: false
  },
  mixins: [upLoadImg],
  data() {
    return {
      dialogShow: false,
      uploadImage,
      picUrl: ''
    };
  },
  methods: {
    saveImg() {
      /**
       * [if description]
       * @param  {[uploadImgList]}  初始化数据 响应初始化 添加 删除
       * @param {[picUrl]}      uploadImgList 最后转化为 picUrl 的值
       */

      if (this.uploadImgList) {
        let len = this.uploadImgList.length;
        if (this.uploadImgList[len - 1].upLoadUrl) {
          // 初始化的图片
          this.picUrl = this.uploadImgList[len - 1].upLoadUrl;
          // this.$set(this, 'picUrl', this.uploadImgList[len - 1].upLoadUrl)
        } else if (this.uploadImgList[len - 1].response.data) {
          // 上传后的图片
          this.picUrl = this.uploadImgList[len - 1].response.data;
        }
      }
    },
    beforeUp(file) {
      const fileTypeList = ['jpg', 'jpeg', 'png', 'webg', ''];
      let testmsg = file.name.substring(file.name.lastIndexOf('.') + 1);
      if (!fileTypeList.includes(testmsg)) {
        this.$notify({
          type: 'error',
          message: '上传类型有误'
        });
        return false;
      }
      const maxSize = 5;
      if (file.size > maxSize * 1024 * 1024) {
        //如果图片大于1m
        this.$notify.error({
          title: '错误',
          message: `上传图片大小不得超过${maxSize}M`
        });
        return false;
      }
    },
    uploadSuccessOne(response, file, fileList) {
      this.uploadImgList = fileList;
      this.saveImg();
      this.$emit('upload-done', this.picUrl);
    },
    dialogClose() {
      this.dialogShow = false;
    },
    dialogConfirm(blob) {
      this.$refs.uploader.handleStart(blob);
      this.$refs.uploader.submit();
      this.dialogShow = false;
    }
  },
  components: {
    CanvasDialog
  },
  computed: {},
  mounted() {},
  watch: {
    initDone(v) {
      if (v) {
        this.getImgList(this.initUrl);
        this.saveImg();
      }
    },
    initUrl: {
      handler(v) {
        if (v) {
          this.getImgList(v);
          this.saveImg();
        }
      },
      immediate: true
    }
  },
  created() {}
};
</script>
<style lang="scss" scoped>
.tip {
  font-size: 14px;
  color: #dd1919;
}
.showPic {
  background-repeat: no-repeat;
  background-size: contain;
  height: 178px;
}
.el-upload__text {
  position: absolute;
  z-index: 9;
  top: 73%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #8c939d;
  font-size: 14px;
  width: 100%;
  text-align: center;
}
</style>
